import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { thoughtspot } from 'config';
import Overlay from 'lib/Overlay';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { thoughtspotLiveboardStyles, filterByMarket, labsReportVisibleActions } from '../utils';
import { LabsLiveboardProps } from '../LabsLiveboard.types';

export const POPLiveMonitoringLiveboard: React.FC<LabsLiveboardProps> = ({ showLiveboard, onHideLiveboard }) => {
  const { marketId } = useSelector((state: Store) => state.publisher.configuration);

  if (!showLiveboard) return null;
  return (
    <Overlay
      onClose={onHideLiveboard}
      isOpen={showLiveboard}
      childrenExtraStyles="flex"
      header={
        <header>
          <h3 className="sub-header-lg text-neutral-900">POP Live Monitoring</h3>
        </header>
      }
    >
      <LiveboardVisuals
        liveboardId={thoughtspot.popLiveMonitoringLiveboardId}
        customizations={thoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[filterByMarket(marketId)]}
      />
    </Overlay>
  );
};
